import { Layout } from 'components/Layout'
import TabProvider from './context/students-provider'
import TabNavigation from './components/TabNavigation'
import StudentList from './components/StudentList'
import WrapFixedButtons from './components/WrapFixedButtons'
import WrapPagination from './components/WrapPagination'
import WrapInputSearch from './components/WrapInputSearch'
import { LumiarToastContainer } from '@legacy/common/_components/LumiarToast'
import { Divider } from '@mantine/core'
import { CurrentUserContextProvider } from 'context/useCurrentUser'
import { WrapTitle } from './components/WrapTitle'
import { NotificationProvider } from 'context'
import { useFeatureToggle } from 'hooks/useFeatureToggle'
import { AddStudentsModalProvider } from 'pages/TeacherDashboard/components/AddStudentsModal'


const StudentsContent = () => (
  <Layout>
    <TabProvider>
      <WrapTitle />
      <Divider my="sm" />
      <WrapInputSearch />
      <TabNavigation />
      <StudentList />
      <WrapPagination />
      <WrapFixedButtons />
      <LumiarToastContainer />
    </TabProvider>
  </Layout>
)

export const Students = () => {
  const isArcNewProjectEnabled = useFeatureToggle('arc-mosaico-project') as boolean

  return (
    <CurrentUserContextProvider>
      <NotificationProvider>
        {isArcNewProjectEnabled ? (
          <AddStudentsModalProvider>
            <StudentsContent />
          </AddStudentsModalProvider>
        ) : (
          <StudentsContent />
        )}
      </NotificationProvider>
    </CurrentUserContextProvider>
  )
}
